import {GESTION_USUARIO_TYPES} from '../constants/gestionUsuario.types'
import {gestionUsuarioInitialState} from '../initital-state/gestionUsuario.state'
import {GestionUsuarioAction, GestionUsuarioState} from '../interfaces/gestion-usuarios.interace'

const gestionUsuarioReducer = (
  state: GestionUsuarioState = gestionUsuarioInitialState,
  action: GestionUsuarioAction
): GestionUsuarioState => {
  switch (action.type) {
    // *******************************************************************************************************
    // ******************* ACCIONES PARA LA CREACION DE USUARIO ***********************************
    // *******************************************************************************************************
    case GESTION_USUARIO_TYPES.CU_FORM_HANDLE_CHANGE:
      return {
        ...state,
        creacionUsuario: {
          ...state.creacionUsuario,
          formUser: {...state.creacionUsuario.formUser, ...action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.CU_FORM_VERIFY_CODE_HANDLE_CHANGE:
      return {
        ...state,
        creacionUsuario: {
          ...state.creacionUsuario,
          codeVerify: {...state.creacionUsuario.codeVerify, ...action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.CU_FORM_ADD_ERROR:
      return {
        ...state,
        creacionUsuario: {
          ...state.creacionUsuario,
          formError: {...state.creacionUsuario.formError, ...action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.CU_FORM_ADD_ERROR_VERIFY_CODE:
      return {
        ...state,
        creacionUsuario: {
          ...state.creacionUsuario,
          codeVerify: {...state.creacionUsuario.codeVerify, ...action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.CU_FORM_CHANGE_PAGE:
      return {
        ...state,
        creacionUsuario: {
          ...state.creacionUsuario,
          paginaActual: state.creacionUsuario.paginaActual + action.payload,
        },
      }
    case GESTION_USUARIO_TYPES.CU_SHOW_MODAL_CONFIRMACION:
      return {
        ...state,
        creacionUsuario: {
          ...state.creacionUsuario,
          modals: {
            ...state.creacionUsuario.modals,
            activoConfirmacion: action.payload,
          },
        },
      }
    case GESTION_USUARIO_TYPES.CU_SHOW_MODAL_VERIFICACION:
      return {
        ...state,
        creacionUsuario: {
          ...state.creacionUsuario,
          modals: {
            ...state.creacionUsuario.modals,
            activoVerificacion: action.payload,
          },
        },
      }
    case GESTION_USUARIO_TYPES.CU_SHOW_MODAL_CONFIRMAR:
      return {
        ...state,
        creacionUsuario: {
          ...state.creacionUsuario,
          modals: {
            ...state.creacionUsuario.modals,
            activoConfirmar: action.payload,
          },
        },
      }
    case GESTION_USUARIO_TYPES.CU_SHOW_MODAL_CREADO:
      return {
        ...state,
        creacionUsuario: {
          ...state.creacionUsuario,
          modals: {
            ...state.creacionUsuario.modals,
            activoCreado: action.payload,
          },
        },
      }
    case GESTION_USUARIO_TYPES.CU_SET_SUCURSALES:
      return {
        ...state,
        creacionUsuario: {
          ...state.creacionUsuario,
          catalogos: {
            ...state.creacionUsuario.catalogos,
            sucursales: action.payload,
          },
        },
      }
    case GESTION_USUARIO_TYPES.CU_SET_SUCURSALES_ASIGNADAS:
      return {
        ...state,
        creacionUsuario: {...state.creacionUsuario, sucursalesAsignadas: action.payload},
      }
    case GESTION_USUARIO_TYPES.CU_SET_ID_USUARIO_CREADO:
      return {
        ...state,
        creacionUsuario: {...state.creacionUsuario, datosUsuarioCreado: action.payload},
      }
    case GESTION_USUARIO_TYPES.CU_FORM_CLEAR:
      return gestionUsuarioInitialState

    // *******************************************************************************************************
    // ******************* ACCIONES PARA LISTAR USUARIO ***********************************
    // *******************************************************************************************************
    case GESTION_USUARIO_TYPES.LU_SET_ARRAY_USUARIOS:
      return {
        ...state,
        listarUsuarios: {...state.listarUsuarios, arrayUsuarios: action.payload},
      }
    case GESTION_USUARIO_TYPES.LU_SET_USUARIOS:
      return {
        ...state,
        listarUsuarios: {...state.listarUsuarios, usuarios: action.payload},
      }
    case GESTION_USUARIO_TYPES.LU_FORM_BUSCAR:
      return {
        ...state,
        listarUsuarios: {
          ...state.listarUsuarios,
          formBuscar: {...state.listarUsuarios.formBuscar, ...action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.LU_CLEAR_FORM_BUSCAR:
      return {
        ...state,
        listarUsuarios: {
          ...state.listarUsuarios,
          formBuscar: gestionUsuarioInitialState.listarUsuarios.formBuscar,
        },
      }
    case GESTION_USUARIO_TYPES.LU_CLEAR:
      return {...state, listarUsuarios: gestionUsuarioInitialState.listarUsuarios}
    case GESTION_USUARIO_TYPES.LU_SHOW_MODAL_ACEPTAR_RECHAZAR:
      return {
        ...state,
        listarUsuarios: {
          ...state.listarUsuarios,
          modales: {...state.listarUsuarios.modales, activeAceptarRechazar: action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.LU_SHOW_MODAL_SUCURSALES:
      return {
        ...state,
        listarUsuarios: {
          ...state.listarUsuarios,
          modales: {...state.listarUsuarios.modales, activeSucursales: action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.LU_SHOW_MODAL_RESET_PASSWORD:
      return {
        ...state,
        listarUsuarios: {
          ...state.listarUsuarios,
          modales: {...state.listarUsuarios.modales, activePassword: action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.LU_SHOW_MODAL_PRINT:
      return {
        ...state,
        listarUsuarios: {
          ...state.listarUsuarios,
          modales: {...state.listarUsuarios.modales, activePrint: action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.LU_SHOW_MODAL_ESTATUS:
      return {
        ...state,
        listarUsuarios: {
          ...state.listarUsuarios,
          modales: {...state.listarUsuarios.modales, activeEstatus: action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.LU_SHOW_MODAL_ELIMINAR_USUARIO:
      return {
        ...state,
        listarUsuarios: {
          ...state.listarUsuarios,
          modales: {...state.listarUsuarios.modales, activeEliminar: action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.LU_SET_SUCURSALES:
      return {
        ...state,
        listarUsuarios: {
          ...state.listarUsuarios,
          catalogos: {
            ...state.listarUsuarios.catalogos,
            sucursales: action.payload,
          },
        },
      }
    case GESTION_USUARIO_TYPES.LU_SET_SUCURSALES_ASIGNADAS:
      return {
        ...state,
        listarUsuarios: {...state.listarUsuarios, sucursalesAsignadas: action.payload},
      }
    case GESTION_USUARIO_TYPES.LU_SET_USUARIO_SELECCIONADO:
      return {
        ...state,
        listarUsuarios: {
          ...state.listarUsuarios,
          usuarioSeleccionado: action.payload,
        },
      }

    // *******************************************************************************************************
    // ******************* ACCIONES PARA EDITAR USUARIO ***********************************
    // *******************************************************************************************************
    case GESTION_USUARIO_TYPES.EU_FORM_EDITAR_HANDLE_CHANGE:
      return {
        ...state,
        editarUsuario: {
          ...state.editarUsuario,
          formUser: {...state.editarUsuario.formUser, ...action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.EU_FORM_EDITAR_ADD_ERROR:
      return {
        ...state,
        editarUsuario: {
          ...state.editarUsuario,
          formError: {...state.editarUsuario.formError, ...action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.EU_SHOW_MODAL_ELIMINAR_USUARIO:
      return {
        ...state,
        editarUsuario: {
          ...state.editarUsuario,
          modales: {...state.editarUsuario.modales, activeEliminar: action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.EU_SET_USUARIO_SELECCIONADO:
      return {
        ...state,
        editarUsuario: {...state.editarUsuario, usuarioSeleccionado: action.payload},
      }
    case GESTION_USUARIO_TYPES.EU_CLEAR:
      return {...state, editarUsuario: gestionUsuarioInitialState.editarUsuario}

    // *******************************************************************************************************
    // ******************* ACCIONES PARA EDITAR USUARIO ***********************************
    // *******************************************************************************************************
    case GESTION_USUARIO_TYPES.ED_SET_ARRAY_ORIGINAL:
      return {
        ...state,
        estadoDocumentos: {...state.estadoDocumentos, arrayOriginalDocumentos: action.payload},
      }
    case GESTION_USUARIO_TYPES.ED_SET_ARRAY_FILTRADO:
      return {
        ...state,
        estadoDocumentos: {...state.estadoDocumentos, arrayFiltradoDocumentos: action.payload},
      }
    case GESTION_USUARIO_TYPES.ED_FORM_BUSCAR:
      return {
        ...state,
        estadoDocumentos: {
          ...state.estadoDocumentos,
          formBuscar: {...state.estadoDocumentos.formBuscar, ...action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.ED_CLEAR_FORM_BUSCAR:
      return {
        ...state,
        estadoDocumentos: {
          ...state.estadoDocumentos,
          formBuscar: gestionUsuarioInitialState.estadoDocumentos.formBuscar,
        },
      }
    case GESTION_USUARIO_TYPES.ED_CLEAR:
      return {...state, estadoDocumentos: gestionUsuarioInitialState.estadoDocumentos}
    case GESTION_USUARIO_TYPES.ED_FORM_CREAR:
      return {
        ...state,
        estadoDocumentos: {
          ...state.estadoDocumentos,
          formCrear: {...state.estadoDocumentos.formCrear, ...action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.ED_FORM_CREAR_ADD_ERROR:
      return {
        ...state,
        estadoDocumentos: {
          ...state.estadoDocumentos,
          formCrearError: {...state.estadoDocumentos.formCrearError, ...action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.ED_CLEAR_FORM_CREAR:
      return {
        ...state,
        estadoDocumentos: {
          ...state.estadoDocumentos,
          formCrear: gestionUsuarioInitialState.estadoDocumentos.formCrear,
          formCrearError: gestionUsuarioInitialState.estadoDocumentos.formCrearError,
        },
      }
    case GESTION_USUARIO_TYPES.ED_SHOW_MODAL_CREAR_EDITAR:
      return {
        ...state,
        estadoDocumentos: {
          ...state.estadoDocumentos,
          modales: {...state.estadoDocumentos.modales, activeCrearEditar: action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.ED_SHOW_MODAL_DOC_CREAR_EDITAR:
      return {
        ...state,
        estadoDocumentos: {
          ...state.estadoDocumentos,
          modales: {...state.estadoDocumentos.modales, activeCrearEditarDoc: action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.ED_SHOW_MODAL_ELIMINAR:
      return {
        ...state,
        estadoDocumentos: {
          ...state.estadoDocumentos,
          modales: {...state.estadoDocumentos.modales, activeEliminar: action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.ED_SHOW_MODAL_CHANGE_ESTATUS:
      return {
        ...state,
        estadoDocumentos: {
          ...state.estadoDocumentos,
          modales: {...state.estadoDocumentos.modales, activeEstatus: action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.ED_SET_DOCUMENTOSELECCIONADO:
      return {
        ...state,
        estadoDocumentos: {...state.estadoDocumentos, documentoSeleccionado: action.payload},
      }
    // *******************************************************************************************************
    // ***************************** ACCIONES PARA PERFIL DE USUARIO *****************************************
    // *******************************************************************************************************
    case GESTION_USUARIO_TYPES.PF_FORM_HANDLE_PROFILE:
      return {
        ...state,
        perfilUsuario: action.payload,
      }
    // *******************************************************************************************************
    // *******************************************************************************************************
    // ***************************** ACCIONES SUCURSALES *****************************************************
    // *******************************************************************************************************

    case GESTION_USUARIO_TYPES.SU_SUCURALES_LIST:
      return {
        ...state,
        sucursales: {...state.sucursales, dataSucursales: action.payload},
      }
    case GESTION_USUARIO_TYPES.SU_SET_FORM_SUCURSAL:
      return {
        ...state,
        sucursales: {
          ...state.sucursales,
          formSucursal: {...state.sucursales.formSucursal, ...action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.SU_SET_ERRORS_FORM_SUCURSAL:
      return {
        ...state,
        sucursales: {
          ...state.sucursales,
          errorsSucursal: {...state.sucursales.errorsSucursal, ...action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.SU_CLEAR_FORM_SUCURSAL:
      return {
        ...state,
        sucursales: {
          ...state.sucursales,
          formSucursal: gestionUsuarioInitialState.sucursales.formSucursal,
          errorsSucursal: gestionUsuarioInitialState.sucursales.errorsSucursal,
        },
      }
    // *******************************************************************************************************
    // *******************************************************************************************************
    // ***************************** ACCIONES SUCURSALES DOCUMENTOS*******************************************
    // *******************************************************************************************************
    case GESTION_USUARIO_TYPES.SU_DOCUMENTOS_SUCURALES_LIST:
      return {
        ...state,
        sucursales: {...state.sucursales, dataDocumentos: action.payload},
      }
    case GESTION_USUARIO_TYPES.SU_SET_FORM_DOC_SUCURSAL:
      return {
        ...state,
        sucursales: {
          ...state.sucursales,
          formDocumento: {...state.sucursales.formDocumento, ...action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.SU_SET_ERRORS_FORM_DOC_SUCURSAL:
      return {
        ...state,
        sucursales: {
          ...state.sucursales,
          errorsDocumento: {...state.sucursales.errorsDocumento, ...action.payload},
        },
      }
    case GESTION_USUARIO_TYPES.SU_CLEAR_FORM_DOC_SUCURSAL:
      return {
        ...state,
        sucursales: {
          ...state.sucursales,
          formDocumento: gestionUsuarioInitialState.sucursales.formDocumento,
          errorsDocumento: gestionUsuarioInitialState.sucursales.errorsDocumento,
        },
      }
    default:
      return state
  }
}

export default gestionUsuarioReducer
